import React from "react";

import { mdiCircleOutline, mdiLoading } from "@mdi/js";
import Icon, { Stack } from "@mdi/react";
import { useTranslation } from "react-i18next";

import { MAX_TIMELINE_Z_INDEX } from "../../../constants/fast";
import useTimelineItems from "../../../hooks/useTimelineItems";

import type { JSX } from "react";

interface SchedulingTimelineLoaderProps {
  isLoading: boolean;
  isUpdateDisabled: boolean;
}

function SchedulingTimelineLoader({
  isLoading,
  isUpdateDisabled,
}: SchedulingTimelineLoaderProps): JSX.Element | null {
  const { t } = useTranslation("editor-fast-channel");
  const { isPartialDataOnCurrentDay } = useTimelineItems();

  const isBackgroundLoading = isLoading && isPartialDataOnCurrentDay === false;

  if (!isLoading && !isUpdateDisabled) return null;

  if (isBackgroundLoading || isUpdateDisabled) {
    return (
      <div
        className="absolute right-0 bottom-0 flex"
        style={{
          zIndex: MAX_TIMELINE_Z_INDEX,
        }}
      >
        <div className="bg-card flex items-center justify-center gap-[0.78125rem] rounded-[0.3125rem] px-[1.09375rem] py-[0.625rem]">
          <Stack size={1}>
            <Icon className="bg-card opacity-20" path={mdiCircleOutline} />
            <Icon spin className="bg-card opacity-80" path={mdiLoading} />
          </Stack>
          {t("synchronisation")}
        </div>
      </div>
    );
  }

  return (
    <div
      className="bg-overlay absolute flex size-full items-end justify-end"
      style={{
        zIndex: MAX_TIMELINE_Z_INDEX,
      }}
    >
      <div className="bg-card flex items-center justify-center gap-[0.78125rem] rounded-tl-lg px-[1.09375rem] py-[0.625rem]">
        <Stack size={1}>
          <Icon className="bg-card opacity-20" path={mdiCircleOutline} />
          <Icon spin className="bg-card opacity-80" path={mdiLoading} />
        </Stack>
        {t("loading")}
      </div>
    </div>
  );
}

export default SchedulingTimelineLoader;
